import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { RadioButton } from "./RadioButton";
const RadioButtonItem = (props) => {
    const { value, ...rest } = props;
    const { onChange, selectedValue, name } = React.useContext(RadioGroupContext);
    return _jsx(RadioButton, { ...rest, value: value, name: name, onChange: () => onChange?.(value), checked: value === selectedValue });
};
const RadioGroupContext = React.createContext(null);
export const RadioButtonGroup = (props) => {
    const { className, style, children, dataSource, onChange, name, textField = "text", valueField = "value", selectedValue, radioClassName, radioStyle, labelClassName, labelStyle } = props;
    if (dataSource) {
        return _jsx("div", { className: className, style: { display: "flex", columnGap: "0.5em", ...style }, children: dataSource.map(item => {
                const text = item[textField];
                const value = item[valueField];
                return _jsx(RadioButton, { disabled: props.disabled, name: name, label: text, value: value, checked: value === selectedValue, onChange: () => onChange?.(value), className: radioClassName, style: radioStyle, labelClassName: labelClassName, labelStyle: labelStyle }, value);
            }) });
    }
    else {
        return _jsx("div", { className: className, style: { display: "flex", columnGap: "0.5em", ...style }, children: _jsx(RadioGroupContext.Provider, { value: props, children: children }) });
    }
};
RadioButtonGroup.Radio = RadioButtonItem;
